export default __webpack_public_path__ + "static/media/grocery.79b3c25a.svg";